import { clearAdminSession, isAdminProtectedPath } from '@/app/admin/admin-auth';
import { clearFrontSessionAndNotify } from '@/app/utils/front-session';

const INVALID_TOKEN_MESSAGE = /invalid\s*token/i;

function isInvalidTokenBizBody(body: unknown): boolean {
  if (body == null || typeof body !== 'object') return false;
  const o = body as Record<string, unknown>;
  const code = o.code;
  const looksLikeBizFail = Number(code) === 1 || code === 1 || code === '1';
  const msg = typeof o.message === 'string' ? o.message.trim() : '';
  return looksLikeBizFail && INVALID_TOKEN_MESSAGE.test(msg);
}

/**
 * HTTP 2xx/4xx 响应体若为 { code: 1, message: Invalid token }：
 * - 当前在后台业务页：清 admin_token 并跳转 /admin/login
 * - 否则（前台）：清 token / user_email / user_id、通知 AuthContext 登出，并跳转首页
 */
export function handleInvalidTokenApiBody(body: unknown): void {
  if (typeof window === 'undefined' || !isInvalidTokenBizBody(body)) return;

  if (isAdminProtectedPath()) {
    clearAdminSession();
    window.location.replace(`${window.location.origin}/admin/login`);
    return;
  }

  clearFrontSessionAndNotify();
  window.location.replace(`${window.location.origin}/`);
}
